import React from 'react';
import CclDataTable, { CclDataTableColumnDef, CclDataTableColumnType } from '../CclDataTable';
import Toaster from "../Toaster";
import ApiDefaultAircraft from "../../code/api/ApiDefaultAircraft";
import DefaultAircraft from "../../code/models/DefaultAircraft";
import "../../css/admindefaulteditors.css";
import ButtonConfirm, { ButtonConfirmSize } from "../ButtonConfirm";

export default function AdminDefaultAircraft() {
    const [toastMessage, setToastMessage] = React.useState<string>("");
    const [aircraftGroups, setAircraftGroups] = React.useState<string[]>([]);
    const [defaultAircraftList, setDefaultAircraftList] = React.useState<DefaultAircraft[] | null>(null);
    const [selectedDefaultAircraft, setSelectedDefaultAircraft] = React.useState<DefaultAircraft | null>(null);
    const [editDefaultAircraft, setEditDefaultAircraft] = React.useState<DefaultAircraft | null>(null);
    const [anyChanges, setAnyChanges] = React.useState<boolean>(false);
    const [groupFilter, setGroupFilter] = React.useState<string>("*");

    React.useEffect(() => {
        loadData();
    }, [groupFilter]);

    React.useEffect(() => {
        loadData();
    }, []);

    React.useEffect(() => {
        if (defaultAircraftList != null && defaultAircraftList.length > 0 && aircraftGroups.length === 0) {
            var ags = defaultAircraftList?.map(a => a.aircraft)
                .filter((value, index, array) => array.indexOf(value) === index);
            setAircraftGroups(ags || []);
        }
    }, [defaultAircraftList]);

    async function loadData() {
        ApiDefaultAircraft.getDefaultAircraft().then(data => {
            let filtered = data.filter(a => groupFilter === "*" || a.aircraft === groupFilter);
            setDefaultAircraftList(filtered);
        });
    }

    function reloadData() {
        setEditDefaultAircraft(null);
        setSelectedDefaultAircraft(null);
        setDefaultAircraftList(null);
        loadData();
    }

    function saveChanges() {
        setToastMessage("");
        if (anyChanges && !!editDefaultAircraft && !!selectedDefaultAircraft) {
            let isNew = !selectedDefaultAircraft.aircraft;
            ApiDefaultAircraft.updateDefaultAircraft(editDefaultAircraft).then(updatedItem => {
                if (!!updatedItem) {
                    selectedDefaultAircraft.aircraft = updatedItem.aircraft;
                    selectedDefaultAircraft.fleetCode = updatedItem.fleetCode;
                    selectedDefaultAircraft.fleetDescription = updatedItem.fleetDescription;
                    selectedDefaultAircraft.configurationCode = updatedItem.configurationCode;
                    selectedDefaultAircraft.configurationDescription = updatedItem.configurationDescription;
                    selectedDefaultAircraft.premiumLevel = updatedItem.premiumLevel;

                    setToastMessage("Default Aircraft Saved.");

                    if (isNew) {
                        reloadData();
                    } else {
                        setEditDefaultAircraft(null);
                        setSelectedDefaultAircraft(null);
                        setAnyChanges(false);
                    }
                }
            });
        }
    }

    function cancelChanges() {
        setEditDefaultAircraft(null);
        setSelectedDefaultAircraft(null);
        setAnyChanges(false);
    }

    function addItem(): void {
        var newRow = new DefaultAircraft();
        newRow.premiumLevel = 0;
        setSelectedDefaultAircraft(newRow);
        setEditDefaultAircraft(structuredClone(newRow));
        setAnyChanges(false);
    }

    function deleteItem(confirm: boolean) {
        if (!selectedDefaultAircraft || !confirm) return;

        ApiDefaultAircraft.deleteDefaultAircraft(selectedDefaultAircraft.aircraft, selectedDefaultAircraft.fleetCode, selectedDefaultAircraft.configurationCode).then(success => {
            if (success) {
                setToastMessage(`Default Aircraft Deleted. (${selectedDefaultAircraft.aircraft}/${selectedDefaultAircraft.fleetCode}/${selectedDefaultAircraft.configurationCode})`);
                reloadData();
            } else {
                setToastMessage("Unable to delete default aircraft.");
            }
        });
    }

    function checkHasChanges() {
        var isAnyChanges = editDefaultAircraft !== null &&
            (selectedDefaultAircraft?.aircraft !== editDefaultAircraft?.aircraft ||
                selectedDefaultAircraft?.fleetCode !== editDefaultAircraft?.fleetCode ||
                selectedDefaultAircraft?.fleetDescription !== editDefaultAircraft?.fleetDescription ||
                selectedDefaultAircraft?.configurationCode !== editDefaultAircraft?.configurationCode ||
                selectedDefaultAircraft?.configurationDescription !== editDefaultAircraft?.configurationDescription ||
                selectedDefaultAircraft?.premiumLevel !== editDefaultAircraft?.premiumLevel);
        setAnyChanges(isAnyChanges);
    }

    function handleRowSelect(rowData: any) {
        setSelectedDefaultAircraft(rowData);
        setEditDefaultAircraft(structuredClone(rowData));
        setAnyChanges(false);
    }

    function buildAircraftGroups() {
        if (!aircraftGroups) return null;
        return aircraftGroups.map(aircraft => {
            return (
                <option value={aircraft} key={"acgrpselo" + aircraft}>{aircraft}</option>
            )
        });
    }

    const profileColumnDefs: CclDataTableColumnDef[] = [
        {
            fieldName: "aircraft",
            title: "Aircraft",
            visible: true,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "fleetCode",
            title: "Fleet Code",
            visible: true,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "fleetDescription",
            title: "Fleet Description",
            visible: true,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "configurationCode",
            title: "Config Code",
            visible: true,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "configurationDescription",
            title: "Config Description",
            visible: true,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "premiumLevel",
            title: "Premium Level",
            visible: true,
            type: CclDataTableColumnType.Data
        }
    ];

    function buildEditor() {
        return (<React.Fragment>
            {!!editDefaultAircraft && !!selectedDefaultAircraft &&
                <div key={"bp" + selectedDefaultAircraft.aircraft + selectedDefaultAircraft.fleetCode + selectedDefaultAircraft.configurationCode}
                    className="row adm-default-editor">
                    <div className="col-1">
                        <label htmlFor="editAircraft" className="form-label text-nowrap">Aircraft</label>
                        <input className="form-control" id="editAircraft" defaultValue={selectedDefaultAircraft.aircraft}
                            maxLength={3} autoComplete={"off"} disabled={!!selectedDefaultAircraft.aircraft}
                            onChange={(e) => {
                                editDefaultAircraft.aircraft = e.target.value;
                                checkHasChanges();
                            }}></input>
                    </div>
                    <div className="col-1">
                        <label htmlFor="editFleetCode" className="form-label text-nowrap">Fleet Code</label>
                        <input className="form-control" id="editFleetCode" defaultValue={selectedDefaultAircraft.fleetCode}
                            maxLength={3} autoComplete={"off"} disabled={!!selectedDefaultAircraft.fleetCode}
                            onChange={(e) => {
                                editDefaultAircraft.fleetCode = e.target.value;
                                checkHasChanges();
                            }}></input>
                    </div>
                    <div className="col-1">
                        <label htmlFor="editFleetDescription" className="form-label text-nowrap">Fleet Description</label>
                        <input className="form-control" id="editFleetDescription" defaultValue={selectedDefaultAircraft.fleetDescription}
                            maxLength={24} autoComplete={"off"}
                            onChange={(e) => {
                                editDefaultAircraft.fleetDescription = e.target.value;
                                checkHasChanges();
                            }}></input>
                    </div>
                    <div className="col-1">
                        <label htmlFor="editConfigurationCode" className="form-label text-nowrap">Config Code</label>
                        <input className="form-control" id="editConfigurationCode" defaultValue={selectedDefaultAircraft.configurationCode}
                            maxLength={3} autoComplete={"off"} disabled={!!selectedDefaultAircraft.configurationCode}
                            onChange={(e) => {
                                editDefaultAircraft.configurationCode = e.target.value;
                                checkHasChanges();
                            }}></input>
                    </div>
                    <div className="col-1">
                        <label htmlFor="editConfigurationDescription" className="form-label text-nowrap">Config Description</label>
                        <input className="form-control" id="editConfigurationDescription" defaultValue={selectedDefaultAircraft.configurationDescription}
                            maxLength={9} autoComplete={"off"}
                            onChange={(e) => {
                                editDefaultAircraft.configurationDescription = e.target.value;
                                checkHasChanges();
                            }}></input>
                    </div>
                    <div className="col-1">
                        <label htmlFor="editPremiumLevel" className="form-label text-nowrap">Premium Level</label>
                        <input className="form-control" id="editPremiumLevel" defaultValue={selectedDefaultAircraft.premiumLevel}
                            type="number" min={0} max={4}
                            onChange={(e) => {
                                editDefaultAircraft.premiumLevel = parseInt(e.target.value, 10);
                                checkHasChanges();
                            }}></input>
                    </div>
                    <div className="col adm-default-actionbuttons text-nowrap">
                        <button disabled={!anyChanges} className="btn btn-primary"
                            onClick={saveChanges}>Save Changes</button>
                        <button className="btn btn-outline-primary"
                            onClick={cancelChanges}>Cancel</button>
                        <ButtonConfirm enabled={!!selectedDefaultAircraft.aircraft} buttonText={"Delete"}
                            confirmTitle={"Default Aircraft"}
                            confirmMessage={`Delete default aircraft '${selectedDefaultAircraft.aircraft}/${selectedDefaultAircraft.fleetCode}/${selectedDefaultAircraft.configurationCode}'?`}
                            buttonSize={ButtonConfirmSize.Normal}
                            cssClass={"btn btn-outline-danger"} onConfirm={deleteItem} />
                    </div>
                </div>}
        </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div className="container-fluid adm-default-main">
                <div className='adm-default-buttonbar'>
                    <button disabled={!defaultAircraftList} className="btn btn-outline-primary" onClick={reloadData}>Reload</button>
                    <button disabled={!defaultAircraftList || (!!selectedDefaultAircraft && !selectedDefaultAircraft.aircraft)} className="btn btn-outline-primary"
                        onClick={addItem}>Add</button>
                    {aircraftGroups.length > 0 &&
                        <div className="col-1">
                            <select id="selectFilterGroup" className="form-select" defaultValue=""
                                onChange={(e) => { setGroupFilter(e.target.value); }}>
                                <option value="*">All</option>
                                {buildAircraftGroups()}
                            </select>
                        </div>}
                </div>
                {buildEditor()}
                <div className='row adm-default-table-wrapper'>
                    <CclDataTable
                        name={"profilesTable"}
                        tableData={defaultAircraftList || []}
                        columnDefinitions={profileColumnDefs}
                        rowSelect={true}
                        onRowSelect={handleRowSelect}
                        onButtonClick={null} />
                </div>
            </div>
            <Toaster title="Default Aircraft" subtitle="" message={toastMessage} key={"defacfttoast"} />
        </React.Fragment>

    )
}
